import { render, staticRenderFns } from "./ModalContact.vue?vue&type=template&id=76450910&scoped=true&lang=pug&"
import script from "./ModalContact.vue?vue&type=script&lang=js&"
export * from "./ModalContact.vue?vue&type=script&lang=js&"
import style0 from "./ModalContact.vue?vue&type=style&index=0&id=76450910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76450910",
  null
  
)

export default component.exports